export function checklistQuestionGuidance(description = "") {
  const sections = {};
  let current = null;
  for (const line of String(description).split(/\r?\n/)) {
    const heading = line.match(/^(Answer type|Required|Supporting requirements|Instructions|References|Explanation rule|Source):\s*(.*)$/i);
    if (heading) {
      current = heading[1].toLowerCase();
      sections[current] = [heading[2]];
    } else if (current) {
      sections[current].push(line);
    }
  }
  return {
    instructions: [sections.instructions, sections["supporting requirements"]]
      .map((lines) => (lines || []).join("\n").trim())
      .filter(Boolean)
      .join("\n\n"),
    references: (sections.references || []).join("\n").trim(),
  };
}
